import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import './recaptcha-widget.less';

const CAPTCHA_SITE_KEY = '6LfYtYIhAAAAAPCB5bipVHhwuP-vEFp6w8TVIWOU';

const RecaptchaWidget = React.forwardRef((props, ref) => (
	<div className="recaptcha-button">
		<ReCAPTCHA
			sitekey={CAPTCHA_SITE_KEY}
			size="invisible"
			badge="inline"
			render="explicit"
			ref={ref}
		/>
		<span className="recaptcha-policy">
			{'This site is protected by reCAPTCHA and the Google '}
			<a href="https://www.totango.com/privacy-policy" target="_blank" rel="noopener noreferrer">
				Privacy Policy
			</a>
			{' and '}
			<a href="https://www.totango.com/terms-of-use" target="_blank" rel="noopener noreferrer">
				Terms of Service
			</a>
			{' apply.'}
		</span>
	</div>
));

export default RecaptchaWidget;
